// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --configuration=student-nonprod` replaces `environment.ts`
// with `environment.student.nonprod.ts`.
// To replace the files aws --profile {profile} s3 sync ./www s3://uoa-student-prompts-spa-bucket-test --delete
// The list of file replacements can be found in `angular.json`.
import { MockWallboardAgents } from './mock/mock-wallboard-agents.json';
import { MockWallboardStats } from './mock/mock-wallboard-stats.json';

export const environment = {
  production: false,
  wallboards: {
    student: {
      stats: {
        title: 'Student Contact Centre',
        baseUrl: 'https://example.com/test/student-stats',
        mockData: MockWallboardStats,
      },
      agents: {
        baseUrl: 'https://example.com/test/student-agents',
        mockData: MockWallboardAgents,
      },
    },
    staff: {
      stats: {
        title: 'Staff Service Centre',
        baseUrl: 'https://example.com/test/staff-stats',
        mockData: MockWallboardStats,
      },
      agents: {
        baseUrl: 'https://example.com/test/staff-agents',
        mockData: MockWallboardAgents,
      },
    },
    prompt: {
      useMockData: false,
      audit: {
        mockData: null,
        baseUrl: 'https://wcrxgfua70.execute-api.ap-southeast-2.amazonaws.com/test/audit',
      },
      prompts: {
        mockData: null,
        baseUrl: 'https://wcrxgfua70.execute-api.ap-southeast-2.amazonaws.com/test/prompts',
      },
      polly: {
        mockData: null,
        baseUrl: 'https://wcrxgfua70.execute-api.ap-southeast-2.amazonaws.com/test/polly',
      },
    },
    phoneNumber: {
      baseUrl: 'https://h0l7fty61m.execute-api.ap-southeast-2.amazonaws.com/test/number-blocker',
      auditUrl: 'https://h0l7fty61m.execute-api.ap-southeast-2.amazonaws.com/test/audit',
    },
  },
  auth: {
    cognitoAwsRegion: 'ap-southeast-2',
    cognitoUserPoolId: 'ap-southeast-2_gtuqqgIIq',
    cognitoDomain: 'https://uoapool-nonprod.auth.ap-southeast-2.amazoncognito.com',
    cognitoClientId: '3ie8d20vumhr3alr6q6ts93hes',
    redirectUri: 'https://amazon-connect-admin-student.test.auckland.ac.nz',
    logoutUri: '',
    scopes: 'openid profile https://contact-centre-student.auckland.ac.nz/prompts-student-spa',
    codeChallengeMethod: 'S256',
  },
  privateUrlKeyWords: {
    whoNeedBearerToken: [
      { url: 'wcrxgfua70.execute-api.ap-southeast-2.amazonaws.com', optional: true },
      { url: 'h0l7fty61m.execute-api.ap-southeast-2.amazonaws.com', optional: true },
    ],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
